import { CacheTab, Translation } from '@enums';
import i18n from '@translations';
import type { TabItem } from '@types';

export const getCacheTabs = (): TabItem[] =>
  [
    {
      key: CacheTab.CACHE_RULES,
      name: i18n.t(`${Translation.Configuration}:tabs.cache.cacheRules`),
    },
  ] as const;
